import { React, useState } from 'react';
import { Alert } from 'react-bootstrap';
import '../BannerNotification/bannernotification.scss';
import {Link} from 'react-router-dom';

function BannerNotification() {
    const user = JSON.parse(localStorage.getItem('user'))
    const expirationDate = user.expirationDate
    const startDate = new Date(expirationDate)
    const endDate = new Date()
    const diff = startDate - endDate
    const diffInDays = diff / (1000 * 60 * 60 * 24);
    const requiredDay = Math.ceil(diffInDays)
    const [show, setShow] = useState(true);
    const preventRedirection = (e) => {
        e.preventDefault();
    }
    return (
        <>

            {show ?
                <div className='banner-notification'>
                    <Alert variant="warning" onClose={() => setShow(false)} dismissible>
                        {
                            //eslint-disable-next-line
                            requiredDay >=0 && requiredDay != -0 ? 
                                <p>Your free trial will expire in {requiredDay ? requiredDay : 'few' } days. Act now to keep your campaigns running after your trail ends without interruption.
                                    <Link onClick={preventRedirection} className='solid-button' to='/#'>Upgrade</Link>
                                </p>
                            :
                            //eslint-disable-next-line
                            requiredDay == -0 ? 
                            <p>Your free trial will expire Today. Act now to keep your campaigns running after your trail ends without interruption.
                                <Link onClick={preventRedirection} className='solid-button' to='/#'>Upgrade</Link>
                            </p>
                            : 
                            <p>Your free trail has ended. Don’t worry, you can always continue where you left off by upgrading the plan. 
                                <Link onClick={preventRedirection} className='solid-button' to='/#'>Upgrade</Link>
                            </p>
                        }
                    </Alert>
                </div>
                :
                ''
            }

        </>
    )
}

export default BannerNotification
